import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { bindMenu, bindTrigger, usePopupState } from 'material-ui-popup-state/hooks';
import { isGridWorkSpaceSelector } from '@/domain/companies/companiesSelector';
import { useExportFormats } from '@/domain/documents/queries/exportFormats';
import { exportFormatOptions } from '@/domain/documents/exportFormats';
import { exportDataAction } from '@/domain/documents/documentsActions';
import * as ACL from '@/domain/restriction';

import Tooltip from '@/components/mui/Tooltip';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

const IconButtonExport = ({ gridRef }) => {
  const dispatch = useDispatch();
  const popupState = usePopupState({ variant: 'popover', popupId: 'LinkedExportMenu' });
  const isGranted = useSelector(ACL.isGranted);
  const isGridView = useSelector(isGridWorkSpaceSelector);
  const { companyId } = useParams();
  const { data: exportFormats = {} } = useExportFormats(companyId ?? null);
  const isVisible = isGranted(ACL.IS_BOOKKEEPER_IN_FINANCIAL_COMPANY);

  const options = exportFormatOptions(exportFormats, isGridView);

  const onClick = useCallback(
    (format) => {
      if (isGridView) {
        const exportFromGridActions = {
          xlsx: gridRef.current.exportAllRowsDataAsExcel,
          csv: gridRef.current.exportAllRowsDataAsCsv,
        };
        exportFromGridActions[format]();
      } else {
        dispatch(exportDataAction({ format }));
      }

      popupState.close();
    },
    [isGridView, dispatch, gridRef, popupState],
  );

  return isVisible ? (
    <>
      <Tooltip
        t={{
          id: 'tooltip.export',
          defaultMessage: 'Export',
        }}
      >
        <IconButton color="primary" {...bindTrigger(popupState)}>
          <FileDownloadOutlinedIcon />
        </IconButton>
      </Tooltip>
      <Menu
        {...bindMenu(popupState)}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {options.map((o) => (
          <MenuItem key={o.value} onClick={() => onClick(o.value)}>
            {o.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  ) : null;
};

export default IconButtonExport;
